import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressBarComponent } from './progress-bar.component';
import {MatStepperModule} from '@angular/material/stepper';



@NgModule({
  declarations: [
    ProgressBarComponent
  ],
  imports: [
    CommonModule,
    MatStepperModule
  ],
    exports : [
      ProgressBarComponent
  ]
})
export class ProgressBarModule { }
